export default "<app-operations-table></app-operations-table>\r\n";